import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createUserGroupEntityInfo } from 'record-it-time-common/entity/entities/UserGroup/createUserGroupEntityInfo';
import { UserGroup } from './userGroupTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export const userGroupEntityInfo = createUserGroupEntityInfo<UserGroup>({
  additionalFieldInfos:
    EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
});
